export default __webpack_public_path__ + "static/media/page2.e34e3d81.png";